import { z } from "zod";
import { CandidateContactPhoneRequestSchema } from "./candidate-contact-verification";

export const TalentNetworkPhoneSignInRequestSchema =
  CandidateContactPhoneRequestSchema.pick({ phone: true }).extend({
    consent: z.literal(true),
  });
export const TalentNetworkPhoneSignInResponseSchema = z.object({
  sent: z.literal(true),
  challengeToken: z.string().min(1).max(2048),
  resendAfterSeconds: z.number().int().positive(),
});
export const TalentNetworkPhoneSignInVerifySchema = z.object({
  phone: CandidateContactPhoneRequestSchema.shape.phone,
  code: z.string().regex(/^\d{6}$/, "Enter the six-digit code"),
  challengeToken: z.string().min(1).max(2048),
});
export type TalentNetworkPhoneSignInRequestDto = z.infer<
  typeof TalentNetworkPhoneSignInRequestSchema
>;
export type TalentNetworkPhoneSignInResponseDto = z.infer<
  typeof TalentNetworkPhoneSignInResponseSchema
>;
export type TalentNetworkPhoneSignInVerifyDto = z.infer<
  typeof TalentNetworkPhoneSignInVerifySchema
>;
